/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import PropTypes from 'prop-types'
import React from 'react'

const Icon = ({ name, ...props }) => {
  const NamedIcon =
    require(`!!@svgr/webpack!../../assets/icons/${name}.svg`).default
  return <NamedIcon {...props} />
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
}

export default Icon
